
import store from '@/store';
import {defineComponent} from 'vue';
import UserInfoDto from "@/dto/UserInfoDto";
import {Modal} from "bootstrap";
import PasswordUtils from "@/utils/PasswordUtils";
import LoadingUtils from "@/utils/LoadingUtils";
import TWebKaiinJoho from "@/entity/TWebKaiinJoho";
import ValidateUtils from "@/utils/ValidateUtils";
import MMailTeikeibun from "@/entity/MMailTeikeibun";
import FormatUtils from "@/utils/FormatUtils";

export default defineComponent({
  name: 'PasswordReminderView',
  components: {},
  async created() {
    this.axios.get('/getConfig', {params: {keys: [
          'keitai_kaisha_docomo',
          'keitai_kaisha_au',
          'keitai_kaisha_softbank',
          'keitai_kaisha_rakuten',
          'mail_domain',
          'pwset_url',
          'pwset_url_kigen',
          'kakunin_cd_kigen']}}).then((res) => {
      this.configs = res.data as { [key: string]: string }
    }).catch()
    this.axios.get('/getMailTemplate', { params: { key: 'pwsettei001' } }).then((res) => {
      this.mailTemplate = res.data as MMailTeikeibun;
    });
  },
  methods:{
    sendResetPasswordMail(){
      LoadingUtils.start()
      this.axios.post('/sendResetPasswordMail', {mailAddress: this.mailAddress}).then((res)=>{
        this.sendDone = true
      }).catch((e)=>{
        console.log(e)
      }).finally(()=>{
        LoadingUtils.end()
      })
    },
    async canSend(): Promise<boolean> {
      this.mailMessage = ''
      let ret = typeof this.mailAddress === 'string' && this.mailAddress.length > 0 && ValidateUtils.isEMailAddress(this.mailAddress);
      if(ret){
        try {
          const res = await this.axios.post('/existsMXRecordFroEmail', { mailAddress: this.mailAddress });
          //追い越し抑止
          if(res.data.mailAddress===this.mailAddress){
            ret = res.data.result as boolean;
            this.mailMessage = 'メールアドレスのドメインが正しくありません。'
          }else{
            console.log('追い越し')
          }
        } catch (e) {
          console.log(e);
          ret = false;
        }
      }else{
        this.mailMessage = 'メールアドレスが正しくありません。'
      }
      return ret;
    },
    async updateCanSend() {
      this.canSendResult = await this.canSend();
    }
  },
  data(){
    return {
      title: 'パスワード再設定',
      configs: {} as { [key: string]: string },
      mailTemplate: {} as MMailTeikeibun,
      mailAddress: '' as string,
      sendDone: false,
      canSendResult: false,
      mailMessage: ''
    }
  },
  computed:{
    FormatUtils() {
      return FormatUtils
    }

  }
});
